module.exports = __webpack_public_path__ + "img/hoch-tiefdruckgeraete.a973785.png";